import { Link } from 'react-router'
import { Box } from '@mui/material'
import { FormattedMessage } from 'react-intl'

import { tokens } from '@configuration/theme'
import Button from '@base/Button/Button.component'
import Divider from '@base/Divider/Divider.component'
import type { SsoBrand } from '@utils/oidc-providers.utils'

import PrimarySsoButtons from '../PrimarySsoButtons/PrimarySsoButtons.component'

interface Props {
  /** Disables every primary-brand button, e.g. while /hrd/config hasn't resolved yet. */
  primaryDisabled?: boolean
  /** `/login/sso` target, carrying the current flow id — see LoginPage.container.tsx. */
  ssoHref: string
  onSubmitPrimary: (brand: SsoBrand) => void
}

// One primary button + a plain grey button linking to the dedicated
// /login/sso page — never per-provider buttons from Kratos flow nodes (see
// PrimarySsoButtons / useSsoRoute). The company-SSO email step itself lives
// on that page now, not inline here.
const SsoSection = ({ primaryDisabled = false, ssoHref, onSubmitPrimary }: Props) => (
  <Box data-testid='sso-section' sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
    <PrimarySsoButtons onClick={onSubmitPrimary} disabled={primaryDisabled} />

    <Button
      variant='bordered'
      size='lg'
      block={true}
      component={Link}
      to={ssoHref}
      dataTestId='sso-page-link'
      sx={{ borderRadius: tokens.radiusMd }}
    >
      <FormattedMessage id='login.sso.companySso' />
    </Button>

    <Divider>
      <FormattedMessage id='login.oidc.orWithEmail' />
    </Divider>
  </Box>
)

export default SsoSection
